<template>
  <v-card class="pa-0 pb-10" tile>
    <v-card-title>
      <h4 class="primary--text">
        {{ copyMode ? $t('tslOrders.duplicateOrder') : (isEditMode ? $t('tslOrders.editOrder') : $t('tslOrders.addOrder')) }}
      </h4>
    </v-card-title>
    <div class="d-flex">
      <div class="tabs-sidebar background">
        <v-tabs v-model="activeTab" vertical background-color="background">
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.client') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.carrier') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.route') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.details') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.preview') }}</v-tab>
        </v-tabs>
      </div>
      <div class="flex-grow-1">
        <v-tabs-items v-model="activeTab" class="py-4">
          <v-tab-item>
            <ClientTab
              v-model="formData.clientContractorId"
              :additional-fields="formData"
              @update="updateClientContractor"
              @update-additional="updateClientAdditionalFields"
            />
          </v-tab-item>
          <v-tab-item>
            <CarrierTab
              v-model="formData.carrierContractorId"
              :additional-fields="formData"
              @update="updateCarrierContractor"
              @update-additional="updateCarrierAdditionalFields"
            />
          </v-tab-item>
          <v-tab-item>
            <RouteTab v-model="formData.places" />
          </v-tab-item>
          <v-tab-item>
            <DetailsTab
              :details="formData"
              @update="updateDetails"
            />
          </v-tab-item>
          <v-tab-item>
            <PreviewTab
              :form-data="formData"
              :client-contractor="clientContractor"
              :carrier-contractor="carrierContractor"
              :is-edit-mode="isEditMode"
              :order-number="orderNumber"
              :order-id="orderId"
              :is-active="activeTab === 4"
              @save="saveOrder"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
    <v-dialog
      v-model="dateDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title>
          {{ $t('fleet.roads.selectFirstDateTitle') }}
        </v-card-title>
        <v-card-text>
          <DatePicker v-model="date" :label="$t('filters.loadDateFrom')" />
        </v-card-text>
        <v-card-actions class="px-6 pb-4 justify-end">
          <v-btn
            outlined
            @click="closeDateDialog"
          >
            {{ $t('languagesSettings.close') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="date == null"
            @click="setDate"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Service from '@/services'
import DatePicker from '@/components/forms/DatePicker'
import ClientTab from './tabs/ClientTab'
import CarrierTab from './tabs/CarrierTab'
import RouteTab from './tabs/RouteTab'
import DetailsTab from './tabs/DetailsTab'
import PreviewTab from './tabs/PreviewTab'

export default {
  name: 'AddTSLOrder',
  components: {
    DatePicker,
    ClientTab,
    CarrierTab,
    RouteTab,
    DetailsTab,
    PreviewTab
  },
  data () {
    return {
      activeTab: 0,
      isEditMode: false,
      orderId: null,
      orderNumber: null,
      dateDialog: false,
      date: null,
      formData: {
        clientContractorId: null,
        carrierContractorId: null,
        places: [],
        notes: '',
        cargoDescription: '',
        ftlLtl: [],
        customsInfo: '',
        cabotageInfo: '',
        adrInfo: '',
        clientPhone: '',
        clientEmail: '',
        clientPrice: null,
        clientCurrency: 0,
        clientRefNumber: '',
        carrierFullName: '',
        carrierPhone: '',
        carrierEmail: '',
        carrierPrice: null,
        carrierCurrency: 0,
        carrierVehicleType: '',
        carrierNotes: '',
        carrierRegistrationNumber: '',
        carrierPaymentType: null,
        carrierPaymentDays: null
      },
      clientContractor: null,
      carrierContractor: null
    }
  },
  computed: {
    copyMode () {
      return this.$route.name === 'CopyTSLOrder'
    }
  },
  created () {
    if (this.copyMode) {
      this.loadOrderForCopy(this.$route.params.id)
    } else {
      this.orderId = this.$route.params.id
      this.isEditMode = !!this.orderId
      if (this.isEditMode) {
        this.loadOrder()
      } else {
        this.applyPreFill()
      }
    }
  },
  methods: {
    applyPreFill () {
      const preFill = this.$store.getters.tslOrderPreFill
      if (!preFill) return

      if (preFill.contractorRole === 'client') {
        this.formData.clientContractorId = preFill.contractorId || null
      } else {
        this.formData.carrierContractorId = preFill.contractorId || null
      }

      if (preFill.places && preFill.places.length > 0) {
        this.formData.places = preFill.places
      }

      this.$store.commit('SET_TSL_ORDER_PRE_FILL', null)
    },
    mapOrderDataToForm (data) {
      return {
        clientContractorId: data.clientContractorId,
        carrierContractorId: data.carrierContractorId,
        places: data.places || [],
        notes: data.notes || '',
        cargoDescription: data.cargoDescription || '',
        ftlLtl: data.ftlLtl || [],
        customsInfo: data.customsInfo || '',
        cabotageInfo: data.cabotageInfo || '',
        adrInfo: data.adrInfo || '',
        clientPhone: data.clientPhone || '',
        clientEmail: data.clientEmail || '',
        clientPrice: data.clientPrice || null,
        clientCurrency: data.clientCurrency ?? 0,
        clientRefNumber: data.clientRefNumber || '',
        carrierFullName: data.carrierFullName || '',
        carrierPhone: data.carrierPhone || '',
        carrierEmail: data.carrierEmail || '',
        carrierPrice: data.carrierPrice || null,
        carrierCurrency: data.carrierCurrency ?? 0,
        carrierVehicleType: data.carrierVehicleType || '',
        carrierNotes: data.carrierNotes || '',
        carrierRegistrationNumber: data.carrierRegistrationNumber || '',
        carrierPaymentType: data.carrierPaymentType || null,
        carrierPaymentDays: data.carrierPaymentDays || null
      }
    },
    async loadOrder () {
      try {
        const { data } = await Service.get('/TSLOrder/GetOrderDetails', { id: this.orderId })
        this.orderNumber = data.orderNumber
        this.formData = this.mapOrderDataToForm(data)
        // Load full contractor details for display
        await this.loadContractorDetails(data.clientContractorId, data.carrierContractorId)
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading order')
        this.$router.push({ name: 'TSLOrders' })
      }
    },
    async loadOrderForCopy (id) {
      try {
        const { data } = await Service.get('/TSLOrder/GetOrderDetails', { id })
        this.formData = this.mapOrderDataToForm(data)
        await this.loadContractorDetails(data.clientContractorId, data.carrierContractorId)
        this.dateDialog = true
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading order')
        this.$router.push({ name: 'TSLOrders' })
      }
    },
    closeDateDialog () {
      this.dateDialog = false
      this.$router.push({ name: 'TSLOrders' })
    },
    setDate () {
      this.dateDialog = false
      const firstPlace = this.formData.places[0]
      if (!firstPlace?.dateTime) {
        return
      }
      const diff = new Date(this.date.split('T')[0]) - new Date(firstPlace.dateTime.split('T')[0])
      this.formData.places.forEach(place => {
        if (place.dateTime) {
          place.dateTime = new Date(new Date(place.dateTime).getTime() + diff).toISOString()
        }
      })
    },
    async loadContractorDetails (clientContractorId, carrierContractorId) {
      try {
        // Load client contractor details
        if (clientContractorId) {
          const { data } = await Service.get('/TSLContractor/GetContractorDetails', { id: clientContractorId })
          this.clientContractor = {
            id: data.id,
            companyName: data.companyName,
            vatNumber: data.vatNumber,
            street: data.street,
            zipCode: data.zipCode,
            city: data.city,
            country: data.country
          }
        }

        // Load carrier contractor details
        if (carrierContractorId) {
          const { data } = await Service.get('/TSLContractor/GetContractorDetails', { id: carrierContractorId })
          this.carrierContractor = {
            id: data.id,
            companyName: data.companyName,
            vatNumber: data.vatNumber,
            street: data.street,
            zipCode: data.zipCode,
            city: data.city,
            country: data.country
          }
        }
      } catch (e) {
        console.error('Error loading contractor details:', e)
      }
    },
    updateClientContractor (contractor) {
      this.clientContractor = contractor
      this.formData.clientContractorId = contractor?.id || null
    },
    updateCarrierContractor (contractor) {
      this.carrierContractor = contractor
      this.formData.carrierContractorId = contractor?.id || null
    },
    updateClientAdditionalFields (fields) {
      Object.assign(this.formData, fields)
    },
    updateCarrierAdditionalFields (fields) {
      Object.assign(this.formData, fields)
    },
    updateDetails (fields) {
      Object.assign(this.formData, fields)
    },
    async saveOrder () {
      try {
        let data
        if (this.isEditMode) {
          const payload = { orderId: this.orderId, ...this.formData }
          const response = await Service.put('/TSLOrder/Update', payload)
          data = response.data
        } else {
          const response = await Service.post('/TSLOrder/Create', this.formData)
          data = response.data
        }
        const message = this.isEditMode
          ? this.$t('tslOrders.messages.orderUpdated', { orderNumber: data.orderNumber })
          : this.$t('tslOrders.messages.orderCreated', { orderNumber: data.orderNumber })
        this.$store.dispatch('setSuccessNotification', message)
        this.$router.push({ name: 'TSLOrders' })
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error saving order')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-sidebar {
  min-width: 250px;
  border-right: 1px solid #e0e0e0;
}

::v-deep .v-tabs {
  height: auto !important;
}

::v-deep .v-tab {
  justify-content: flex-start !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  letter-spacing: normal !important;
  padding: 20px 24px !important;
  min-height: 60px !important;
  height: auto !important;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(0, 100, 70, 0.1) !important;
  }

  &.v-tab--active {
    background-color: #006446 !important;
    color: white !important;
    font-weight: 600 !important;

    &::before {
      opacity: 0 !important;
    }
  }
}
</style>
